/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_UnknownInputs */

const en_us2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service sent a note this version of the app doesn't know yet. Update the app to read it.`)
};

const pt_br2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O serviço mandou uma observação que esta versão do app ainda não conhece. Atualize o app para ler.`)
};

const es_419_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El servicio envió una observación que esta versión de la app todavía no conoce. Actualiza la app para leerla.`)
};

const pt_pt2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O serviço enviou uma observação que esta versão da app ainda não conhece. Atualiza a app para a leres.`)
};

const fr_fr2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le service a envoyé une remarque que cette version de l'app ne connaît pas encore. Mets l'app à jour pour la lire.`)
};

const de_de2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Dienst hat einen Hinweis geschickt, den diese App-Version noch nicht kennt. Aktualisiere die App, um ihn zu lesen.`)
};

const it_it2_body_assessment_warning_unknown = /** @type {(inputs: Body_Assessment_Warning_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il servizio ha inviato una nota che questa versione dell'app non conosce ancora. Aggiorna l'app per leggerla.`)
};

/**
* | output |
* | --- |
* | "The service sent a note this version of the app doesn't know yet. Update the app to read it." |
*
* @param {Body_Assessment_Warning_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_unknown = /** @type {((inputs?: Body_Assessment_Warning_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_unknown(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_unknown(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_unknown(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_unknown(inputs)
	return en_us2_body_assessment_warning_unknown(inputs)
});
export { body_assessment_warning_unknown as "body-assessment.warning.unknown" }